import * as crypto from 'crypto-js';

import { formatDate } from "@angular/common";
import { Component, OnInit } from '@angular/core';


@Component({
	selector: 'app-proceedings26',
	templateUrl: './proceedings.component.html',
	styleUrls: ['./proceedings.component.css']
})
export class ProceedingsComponent26 implements OnInit {
	
	constructor() {}

	ngOnInit(): void {}
	
}